import React, { useState } from "react";
import { MdEmail, MdPhone } from "react-icons/md";

// const API_GATEWAY_URL = "https://oa2c84ws00.execute-api.us-east-1.amazonaws.com/Prod/submit";
const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL;

const Contact = () => {
  // formData state now uses keys matching your Lambda's expected payload
  const [formData, setFormData] = useState({
    userName: "", // Changed from 'name'
    userEmail: "", // Changed from 'email'
    userPhone: "", // Changed from 'phone'
    message: "",
  });
  // State variables to manage feedback messages to the user
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Function for client-side form validation
  const validateForm = () => {
    // Clear previous error message
    setErrorMessage("");

    // Basic check for empty fields (using the new keys)
    if (
      !formData.userName.trim() ||
      !formData.userEmail.trim() ||
      !formData.userPhone.trim() ||
      !formData.message.trim()
    ) {
      setErrorMessage("Please fill in all required fields.");
      return false;
    }

    // Basic email format validation using a regex (using the new key)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.userEmail)) {
      setErrorMessage("Please enter a valid email address.");
      return false;
    }

    // You can add more complex validations here (e.g., phone number format, message length)

    return true; // Form is valid
  };

  const handleChange = (e) => {
    // Clear messages when user starts typing again
    setSuccessMessage("");
    setErrorMessage("");

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Placeholder function: Implement your logic if you need to control
  // form visibility or other UI elements after submission.
  const onFormVisibility = () => {
    console.log("onFormVisibility called. Add your UI logic here.");
    // Example: set a state to hide the form or show a 'Thank You' component
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    setLoading(true);
    // Perform client-side validation
    if (!validateForm()) {
      return; // Stop the submission if validation fails
    }

    try {
      // Send the form data to your AWS API Gateway endpoint
      const response = await fetch(API_GATEWAY_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Crucial for Lambda to parse the JSON body
          // If you face CORS issues (e.g., "No 'Access-Control-Allow-Origin' header"),
          // you might need to specify your domain here, but ensure API Gateway CORS is configured first.
          // Example: 'Access-Control-Allow-Origin': 'https://gr8appers.com',
        },
        body: JSON.stringify(formData), // Convert JavaScript object to JSON string
      });

      // Check if the response status is in the 2xx range (success)
      if (response.ok) {
        const result = await response.json(); // Parse the JSON response from your Lambda
        setSuccessMessage(
          "Your Registration Request has been submitted successfully!"
        );
        setErrorMessage(""); // Clear any previous error messages
        console.log("API Success Response:", result);

        // Clear the form fields after successful submission (using the new keys)
        setFormData({
          userName: "",
          userEmail: "",
          userPhone: "",
          message: "",
        });

        // Optionally, redirect the user or perform other UI actions
        // window.location.href = '/success';
      } else {
        // If the response is not OK (e.g., 400, 500), try to get error details from the body
        let errorDetails =
          "There was an error sending your message. Please try again.";
        try {
          const errorResponseData = await response.json();
          if (errorResponseData && errorResponseData.message) {
            errorDetails = errorResponseData.message;
          }
        } catch (jsonError) {
          console.warn("Could not parse error response as JSON:", jsonError);
          // Fallback to generic message if response body isn't JSON
        }
        throw new Error(errorDetails);
      }
    } catch (error) {
      setErrorMessage(error.message); // Display the caught error message to the user
      setSuccessMessage(""); // Clear any success message
      console.error("Form submission failed:", error);
    }
    setLoading(false);

    // Call the visibility handler after form submission attempt
    onFormVisibility();
  };

  return (
    <div className="contactSection">
      {/* Note: No hidden Netlify forms are required as you are directly
          interacting with your AWS API Gateway/Lambda. */}

      <div className="container">
        <div className="contactLeft">
          <p className="subheading">We are here to help you</p>
          <h2 className="headline">
            Get <b>Expert Guidance</b> Tailored for You
          </h2>
          <p className="description">
            Are you looking for personalized career insights, skill assessment,
            or study-abroad support? Fill in the form — we’ll help you take the
            next right step.
          </p>
          <div className="contactInfo">
            <div className="contactLine">
              <MdPhone className="icon" />
              <span>+91 90420 77338</span>
            </div>
            <div className="contactLine">
              <MdEmail className="icon" />
              <a href="mailto:contact@gr8appers.com">contact@gr8appers.com</a>
            </div>
          </div>
        </div>

        <form className="contactForm" onSubmit={handleSubmit}>
          {/* Display success or error messages to the user */}
          {successMessage && (
            <p style={{ color: "green", fontWeight: "bold" }}>
              {successMessage}
            </p>
          )}
          {errorMessage && (
            <p style={{ color: "red", fontWeight: "bold" }}>{errorMessage}</p>
          )}

          <div className="inputRow">
            <input
              type="text"
              name="userName" // <<< UPDATED: Matches the payload key 'userName'
              placeholder="Full Name"
              value={formData.userName}
              onChange={handleChange}
              className="input"
              required // HTML5 validation for basic browser-level checks
            />
          </div>
          <div className="inputRow">
            <input
              type="email"
              name="userEmail" // <<< UPDATED: Matches the payload key 'userEmail'
              placeholder="Email"
              value={formData.userEmail}
              onChange={handleChange}
              className="input threeFourth"
              required
            />
            <input
              type="tel"
              name="userPhone" // <<< UPDATED: Matches the payload key 'userPhone'
              placeholder="Phone"
              value={formData.userPhone}
              onChange={handleChange}
              className="input half"
              required
            />
          </div>
          <div className="inputRow">
            <textarea
              name="message" // Matches payload key 'message'
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              className="textarea"
              required
            ></textarea>
          </div>
          <div className="inputRow col">
            <button disabled={loading} type="submit" className="submit-btn">
              {loading ? (
                "Submitting..."
              ) : (
                <>
                  Register for <b>Free</b>
                </>
              )}
            </button>
            <p className="privacy-note">
              By submitting this form you agree to the{" "}
              <a href="/privacy-policy">privacy policy</a>.
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Contact;
